import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '../../../store/actions';
import { useIsWidgetsEnabled } from './useIsWidgetsEnabled';

export const useLogout = () => {
    const { enableInbox } = useIsWidgetsEnabled();
    const dispatch = useDispatch();

    return useCallback(() => {
        if (!window.Communication) {
            return;
        }

        (async () => {
            window.Communication.API.common.logout();
            enableInbox && await window.Communication.API.inbox.unSubscribe();
            dispatch(actions.setIsWidgetsAuthenticated(false));
        })();
    }, [dispatch, enableInbox]);
};
